import styled from 'styled-components';

import media from 'apps/promo/theme/media';
import zIndex from 'apps/promo/theme/zIndex';

export const Container = styled.div`
    position: fixed;
    bottom: ${(props) => (props.pressedAboveCookieButton ? '88px' : '24px')};
    left: 0;
    right: 0;
    height: 0;
    pointer-events: none;
    z-index: ${zIndex.bottomPanelIndex};
`;
export const Inner = styled.div`
    margin: 0 auto;
    padding: 0 24px;
    position: absolute;
    right: 0;
    left: 0;
    bottom: 0;
    display: flex;
    justify-content: flex-end;
    box-sizing: ${(props) => (props.pressedAboveCookieButton ? null : 'border-box')};
    /* content width 480 */
    max-width: 528px;

    ${media.tablet720} {
        padding: 0 24px;
        /* content width 504px */
        max-width: 552px;
    }
    ${media.tablet1080} {
        max-width: ${(props) => (props.pressedAboveCookieButton ? null : '840px')};
    }
    ${media.desktop1224} {
        margin: 0 auto;
    }

    ${media.desktop1440} {
        max-width: ${(props) => (props.pressedAboveCookieButton ? '1280px' : null)};
        padding-left: ${(props) => (props.pressedAboveCookieButton ? '160px' : null)};
        padding-right: ${(props) => (props.pressedAboveCookieButton ? '160px' : null)};
    }
`;
